import React, { useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import successIcon from './success-icon.svg'

const CertificateSigned = () => {
  const formattedDate = useMemo(() => {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }).format(new Date())
  }, [])

  const summaryItems = [
    { label: 'Status', value: 'Assinatura concluída' },
    { label: 'Registro', value: formattedDate },
  ]

  return (
    <div className="certificate-signed">
      <div className="certificate-signed__container">
        <img className="certificate-signed__icon" src={successIcon} alt="Documento assinado com sucesso" />

        <h1 className="certificate-signed__title">Documento assinado com sucesso</h1>

        <p className="certificate-signed__message">
            Obrigado por assinar o documento, você pode visualizar o certificado de entrega assinado na seção de certificados.
        </p>

        <ul className="certificate-signed__summary-list">
          {summaryItems.map(item => (
            <li key={item.label} className="certificate-signed__summary-item">
              <span className="certificate-signed__summary-label">{item.label}</span>
              <span className="certificate-signed__summary-value">{item.value}</span>
            </li>
          ))}
        </ul>

        <div className="certificate-signed__actions">
          <NavLink to="/admin/certificados-entrega" className="certificate-signed__action-link">
            Ver certificados
          </NavLink>
          <NavLink to="/admin/dashboard" className="certificate-signed__action-link">
            Voltar ao dashboard
          </NavLink>
        </div>
       </div>
    </div>
  )
}

export default CertificateSigned